import getEditToken from "../../getters/editToken";

const bpmnToken = getEditToken("bpmn");
export default bpmnToken;
